var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeblink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Weblink__Icn/40px/Weblink",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Weblink__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Weblink__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Weblink__Group-Copy-2",
    transform: "rotate(-45 35.607 5.757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66025404,0.5 C10.9899382,0.5 12.9474852,2.09330845 13.5026499,4.2496802 L15.8178582,4.2496802 C16.3730229,2.09330845 18.3305699,0.5 20.660254,0.5 L23.660254,0.5 C26.4216778,0.5 28.660254,2.73857625 28.660254,5.5 C28.660254,8.26142375 26.4216778,10.5 23.660254,10.5 L20.660254,10.5 C18.3302137,10.5 16.3724243,8.90620426 15.8176037,6.74933059 L13.5029044,6.74933059 C12.9480838,8.90620426 10.9902944,10.5 8.66025404,10.5 L5.66025404,10.5 C2.89883029,10.5 0.660254038,8.26142375 0.660254038,5.5 C0.660254038,2.73857625 2.89883029,0.5 5.66025404,0.5 L8.66025404,0.5 Z M23.660254,2.5 L20.660254,2.5 C19.4499251,2.5 18.4069997,3.21673951 17.9327667,4.2489296 L20.6401367,4.25 C21.3304927,4.25 21.8901367,4.80964406 21.8901367,5.5 C21.8901367,6.14720869 21.3982621,6.6795339 20.767942,6.74354639 L20.6401367,6.75 L17.9323093,6.7500743 C18.3831613,7.73232532 19.3489228,8.42914051 20.4839812,8.49490731 L20.660254,8.5 L23.660254,8.5 C25.3171083,8.5 26.660254,7.15685425 26.660254,5.5 C26.660254,3.90231912 25.4113341,2.59633912 23.8365268,2.50509269 L23.660254,2.5 Z M8.66025404,2.5 L5.66025404,2.5 C4.00339979,2.5 2.66025404,3.84314575 2.66025404,5.5 C2.66025404,7.09768088 3.909174,8.40366088 5.48398125,8.49490731 L5.66025404,8.5 L8.66025404,8.5 C9.87097225,8.5 10.9141793,7.78279934 11.3881988,6.7500743 L9,6.75 C8.30964406,6.75 7.75,6.19035594 7.75,5.5 C7.75,4.85279131 8.24187466,4.3204661 8.87219476,4.25645361 L9,4.25 L11.3877414,4.2489296 C10.9366938,3.26720362 9.97120154,2.57083726 8.83652683,2.50509269 L8.66025404,2.5 Z",
    id: ".._.._src_svg_Icn_40px_Weblink__Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeblink);
export default __webpack_public_path__ + "static/media/Weblink.8715d37ffef812875afcc113cb5d45aa.svg";
export { ForwardRef as ReactComponent };